import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AbstractHttpService } from './abstract-http-service';

export interface OfferSetPublicOffersDto {
  standardOfferSetId: number | null;
  matchedOfferSetId: number | null;
  matchedOfferSetTitle: string | null;
  leaseOfferIsPublic: boolean;
  alternateLeaseIsPublic: boolean;
  aprOfferIsPublic: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class OfferSetPublicOffersService extends AbstractHttpService {
  private readonly defaultOptions = {
    headers: this.contentTypeJsonHeaders,
    withCredentials: true
  };

  public constructor(private readonly httpClient: HttpClient) {
    super();
  }

  public getPublicOffersByOfferSetIds(offerSetIds: number[]): Observable<OfferSetPublicOffersDto[]> {
    const sanitizedOfferSetIds = offerSetIds
      .filter((id) => Number.isFinite(id) && id > 0);

    const uniqueOfferSetIds = Array.from(new Set(sanitizedOfferSetIds));
    const offerSetIdsValue = uniqueOfferSetIds.join(',');

    const params = new HttpParams().set('offerSetIds', offerSetIdsValue);

    return this.httpClient.get<OfferSetPublicOffersDto[]>(
        `//${environment.autoDomain}:${environment.autoPort}/api/offers-registry/public-offers`,
        {
          ...this.defaultOptions,
          params
        }
      )
      .pipe(catchError(this.handleError));
  }
}
